import { render } from "./LearningVideos.vue?vue&type=template&id=274b1be7"
import script from "./LearningVideos.vue?vue&type=script&lang=js"
export * from "./LearningVideos.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__